<template>
  <div>
    <slot name="content" v-bind="this"></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rrss: false,
      close: true,
    }
  },
  methods: {
    view() {
      this.rrss = !this.rrss;
      this.close = !this.close;
    }
  },
  mounted() {
    console.log('Im a component Share');
  }
}
</script>
